module.exports = __webpack_public_path__ + "img/product-04.8b2d26f7.jpg";